<p-toast></p-toast>
<p-progressBar mode="indeterminate" *ngIf="loading || processing"></p-progressBar>

<app-page-shell>

  <app-page-hero
    eyebrow="Shipments"
    title="Delivery Rate Cards"
    subtitle="Manage contract-linked lane rates and upload revision rate-card templates.">
    <div actions>
      <p-button label="Template XLSX" icon="pi pi-download" severity="secondary" [outlined]="true" (onClick)="downloadTemplate('xlsx')"></p-button>
      <p-button label="Template CSV" icon="pi pi-file" severity="secondary" [outlined]="true" (onClick)="downloadTemplate('csv')"></p-button>
      <p-button label="Add Rate" icon="pi pi-plus" [disabled]="!canCreate" (onClick)="openCreate()"></p-button>
    </div>
  </app-page-hero>

  <app-page-metric-strip [metrics]="metrics()"></app-page-metric-strip>

  <app-page-data-panel title="Filters" subtitle="Find rates by contract, revision, lane, vehicle, or status." [resultText]="totalRecords + ' rates'" [collapsible]="true" [initiallyCollapsed]="true">
    <div actions>
      <p-button label="Apply" icon="pi pi-search" severity="secondary" [outlined]="true" (onClick)="applyFilters()"></p-button>
      <p-button label="Clear" icon="pi pi-times" severity="secondary" [text]="true" (onClick)="clearFilters()"></p-button>
    </div>
    <div class="filter-grid formgrid grid">
      <div class="field col-12 md:col-6 xl:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="fa-solid fa-file-contract"></i></p-inputGroupAddon>
          <p-iftaLabel class="w-full">
            <p-select inputId="filterContract" styleClass="w-full" [options]="contracts" [(ngModel)]="filterContractId" optionLabel="contractNumber" optionValue="contractID" [filter]="true" filterBy="contractNumber,firstParty.name,secondParty.name" [showClear]="true" (onChange)="onFilterContractChange()">
              <ng-template pTemplate="selectedItem" let-contract>
                <span>{{ contractDisplayLabel(contract) }}</span>
              </ng-template>
              <ng-template pTemplate="item" let-contract>
                <div class="contract-option">
                  <strong>{{ contract.contractNumber }}</strong>
                  <small>{{ contractPartiesLabel(contract) }}</small>
                </div>
              </ng-template>
            </p-select>
            <label for="filterContract">Contract</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-6 xl:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="fa-solid fa-code-branch"></i></p-inputGroupAddon>
          <p-iftaLabel class="w-full">
            <p-select inputId="filterRevision" styleClass="w-full" [options]="filterRevisions" [(ngModel)]="filterRevisionId" optionLabel="revisionNumber" optionValue="revisionID" [showClear]="true" (onChange)="applyFilters()"></p-select>
            <label for="filterRevision">Revision</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-6 xl:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="fa-solid fa-circle-check"></i></p-inputGroupAddon>
          <p-iftaLabel class="w-full">
            <p-select inputId="filterStatus" styleClass="w-full" [options]="revisionStatusOptions" [(ngModel)]="filterRevisionStatus" optionLabel="label" optionValue="value" [showClear]="true" (onChange)="applyFilters()"></p-select>
            <label for="filterStatus">Revision Status</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-6 xl:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="fa-solid fa-magnifying-glass"></i></p-inputGroupAddon>
          <p-iftaLabel class="w-full">
            <input id="keyword" class="w-full" pInputText [(ngModel)]="keyword" (keyup.enter)="applyFilters()">
            <label for="keyword">Keyword</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-6 xl:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="fa-solid fa-globe"></i></p-inputGroupAddon>
          <p-iftaLabel class="w-full">
            <p-select inputId="sourceCountry" styleClass="w-full" [options]="countries" [(ngModel)]="filterSourceCountryId" optionLabel="name" optionValue="id" [filter]="true" filterBy="name,countryCode" [showClear]="true" (onChange)="onFilterSourceCountryChange()"></p-select>
            <label for="sourceCountry">Source Country</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-6 xl:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="fa-solid fa-location-dot"></i></p-inputGroupAddon>
          <p-iftaLabel class="w-full">
            <p-select inputId="sourceCity" styleClass="w-full" [options]="filterSourceCities" [(ngModel)]="filterSourceCityId" optionLabel="cityName" optionValue="id" [filter]="true" filterBy="cityName" [showClear]="true" [disabled]="!filterSourceCountryId" (onChange)="applyFilters()"></p-select>
            <label for="sourceCity">Source City</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-6 xl:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="fa-solid fa-globe"></i></p-inputGroupAddon>
          <p-iftaLabel class="w-full">
            <p-select inputId="destinationCountry" styleClass="w-full" [options]="countries" [(ngModel)]="filterDestinationCountryId" optionLabel="name" optionValue="id" [filter]="true" filterBy="name,countryCode" [showClear]="true" (onChange)="onFilterDestinationCountryChange()"></p-select>
            <label for="destinationCountry">Destination Country</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-6 xl:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="fa-solid fa-map-pin"></i></p-inputGroupAddon>
          <p-iftaLabel class="w-full">
            <p-select inputId="destinationCity" styleClass="w-full" [options]="filterDestinationCities" [(ngModel)]="filterDestinationCityId" optionLabel="cityName" optionValue="id" [filter]="true" filterBy="cityName" [showClear]="true" [disabled]="!filterDestinationCountryId" (onChange)="applyFilters()"></p-select>
            <label for="destinationCity">Destination City</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-6 xl:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="fa-solid fa-truck"></i></p-inputGroupAddon>
          <p-iftaLabel class="w-full">
            <p-select inputId="vehicleType" styleClass="w-full" [options]="vehicleTypes" [(ngModel)]="filterVehicleTypeId" optionLabel="name" optionValue="id" [filter]="true" filterBy="name" [showClear]="true" (onChange)="onFilterVehicleTypeChange()"></p-select>
            <label for="vehicleType">Vehicle Type</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-6 xl:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="fa-solid fa-sliders"></i></p-inputGroupAddon>
          <p-iftaLabel class="w-full">
            <p-select inputId="vehicleConfig" styleClass="w-full" [options]="vehicleConfigs" [(ngModel)]="filterVehicleConfigId" optionLabel="name" optionValue="configId" [filter]="true" filterBy="name" [showClear]="true" (onChange)="applyFilters()"></p-select>
            <label for="vehicleConfig">Vehicle Config</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field col-12 md:col-6 xl:col-3">
        <p-inputGroup>
          <p-inputGroupAddon><i class="fa-solid fa-weight-hanging"></i></p-inputGroupAddon>
          <p-iftaLabel class="w-full">
            <p-select inputId="vehicleCapacity" styleClass="w-full" [options]="vehicleCapacities" [(ngModel)]="filterVehicleCapacityId" optionLabel="name" optionValue="capacityId" [filter]="true" filterBy="name" [showClear]="true" (onChange)="applyFilters()"></p-select>
            <label for="vehicleCapacity">Vehicle Capacity</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
    </div>
  </app-page-data-panel>

  <app-page-data-panel title="Rate Cards" subtitle="Contract and revision links remain attached to every lane rate." [resultText]="rateCards.length + ' shown'">
    <ng-template #rateGroupsTemplate>
      <div class="client-rate-groups" *ngIf="activeRateGroups.length; else noRateGroups">
        <section class="client-rate-group" *ngFor="let group of activeRateGroups">
          <div class="client-rate-header">
            <div class="client-rate-title">
              <span>{{ group.roleLabel }}</span>
              <strong>{{ group.clientName }}</strong>
            </div>
            <div>
              <span>Rates</span>
              <strong>{{ group.rates.length }}</strong>
            </div>
            <div>
              <span>Total Amount</span>
              <strong>{{ group.totalAmount | number:'1.2-2' }}</strong>
            </div>
          </div>

          <p-table [value]="group.rates" dataKey="rateId" [loading]="loading" styleClass="p-datatable-gridlines rate-table" [tableStyle]="{ 'min-width': '96rem' }">
            <ng-template pTemplate="header">
              <tr>
                <th>Contract</th>
                <th>Revision</th>
                <th>Lane</th>
                <th>Vehicle</th>
                <th>Amount</th>
                <th>Waiting</th>
                <th>Terms</th>
                <th class="text-right">Actions</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rate>
              <tr>
                <td>
                  <strong>{{ contractDisplay(rate) }}</strong>
                  <div class="muted">Rate #{{ rate.rateId }}</div>
                </td>
                <td>
                  <p-tag *ngIf="rate.revisionStatus" [value]="rate.revisionStatus" [severity]="statusSeverity(rate.revisionStatus)"></p-tag>
                  <div class="muted">{{ revisionDisplay(rate) }}</div>
                </td>
                <td>
                  <strong>{{ rate.sourceCityName || rate.sourceCity }} -> {{ rate.destinationCityName || rate.destinationCity }}</strong>
                  <div class="muted">{{ countryLabelForRate(rate, 'source') }} -> {{ countryLabelForRate(rate, 'destination') }}</div>
                </td>
                <td>
                  <strong>{{ rate.vehicleTypeName || vehicleTypeName(rate.vehicleTypeId) }}</strong>
                  <div class="muted">{{ rate.vehicleConfigName || '-' }} / {{ rate.vehicleCapacityName || '-' }}</div>
                </td>
                <td>{{ rate.amount | number:'1.2-2' }}</td>
                <td>{{ rate.waitingCharge || 0 | number:'1.2-2' }} / {{ rate.waitingThreshold || 0 }} mins</td>
                <td>
                  <span>Insurance: {{ rate.goodsInsurance === true ? 'Yes' : rate.goodsInsurance === false ? 'No' : '-' }}</span><br>
                  <span>Permit: {{ rate.portPermit === true ? 'Yes' : rate.portPermit === false ? 'No' : '-' }}</span>
                </td>
                <td class="text-right">
                  <button pButton type="button" icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-secondary mr-2" [disabled]="!canEdit" (click)="openEdit(rate)"></button>
                  <button pButton type="button" icon="pi pi-trash" class="p-button-rounded p-button-text p-button-danger" [disabled]="!canDelete" (click)="deleteRateCard(rate)"></button>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </section>
      </div>
      </ng-template>

    <ng-template #noRateGroups>
      <div class="empty-state">No delivery rate cards match the current filters.</div>
    </ng-template>

    <p-tabs styleClass="rate-tabs" [value]="activeRateRole" (valueChange)="onRateRoleChange($event)">
      <p-tablist>
        <p-tab value="seller">Seller Rates</p-tab>
        <p-tab value="buyer">Buyer Rates</p-tab>
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel value="seller">
          <ng-container *ngTemplateOutlet="rateGroupsTemplate"></ng-container>
        </p-tabpanel>
        <p-tabpanel value="buyer">
          <ng-container *ngTemplateOutlet="rateGroupsTemplate"></ng-container>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </app-page-data-panel>

  <app-page-data-panel title="Upload Rate Cards" subtitle="Select one contract revision, upload XLSX/XLS/CSV, correct invalid rows, then process valid rows.">
    <div actions>
      <p-button label="Process Valid Rows" icon="pi pi-check" [loading]="processing" [disabled]="!currentImport?.batch?.validRows || !canCreate" (onClick)="processBatch()"></p-button>
      <p-button label="Failed Rows" icon="pi pi-file-export" severity="secondary" [outlined]="true" [disabled]="!currentImport?.rows?.length" (onClick)="exportFailedRows()"></p-button>
    </div>
    <div class="upload-grid">
      <p-iftaLabel class="w-full">
        <p-select inputId="importContract" styleClass="w-full" [options]="contracts" [(ngModel)]="importContract" optionLabel="contractNumber" [filter]="true" filterBy="contractNumber,firstParty.name,secondParty.name" [showClear]="true" (onChange)="onImportContractChange()">
          <ng-template pTemplate="selectedItem" let-contract>
            <span>{{ contractDisplayLabel(contract) }}</span>
          </ng-template>
          <ng-template pTemplate="item" let-contract>
            <div class="contract-option">
              <strong>{{ contract.contractNumber }}</strong>
              <small>{{ contractPartiesLabel(contract) }}</small>
            </div>
          </ng-template>
        </p-select>
        <label for="importContract">Contract</label>
      </p-iftaLabel>
      <p-iftaLabel class="w-full">
        <p-select inputId="importRevision" styleClass="w-full" [options]="importRevisions" [(ngModel)]="importRevision" optionLabel="revisionNumber" [showClear]="true" (onChange)="onImportRevisionChange()"></p-select>
        <label for="importRevision">Revision</label>
      </p-iftaLabel>
      <label class="file-picker">
        <i class="pi pi-upload"></i>
        <span>{{ importFile?.name || 'Choose XLSX, XLS, or CSV file' }}</span>
        <input type="file" accept=".xlsx,.xls,.csv" (change)="onFileSelected($event)">
      </label>
      <p-button label="Upload & Validate" icon="pi pi-cloud-upload" [disabled]="!importFile || !importContract || !importRevision || !canCreate" [loading]="loading" (onClick)="uploadImport()"></p-button>
    </div>
  </app-page-data-panel>

  <app-page-data-panel title="Review Import Rows" subtitle="Rows marked invalid must be corrected before processing." [resultText]="filteredRows.length + ' rows'">
    <p-table [value]="filteredRows" dataKey="rowId" styleClass="p-datatable-gridlines" [tableStyle]="{ 'min-width': '86rem' }" [paginator]="true" [rows]="12">
      <ng-template pTemplate="header">
        <tr>
          <th>Row</th>
          <th>Status</th>
          <th>Lane</th>
          <th>Vehicle</th>
          <th>Amount</th>
          <th>Created Rate</th>
          <th>Error</th>
          <th class="text-right">Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td>{{ row.sheetName }} #{{ row.rowNumber }}</td>
          <td><p-tag [value]="row.status" [severity]="statusSeverity(row.status)"></p-tag></td>
          <td>
            <strong>{{ rowImportValue(row, 'sourceCity') }} -> {{ rowImportValue(row, 'destinationCity') }}</strong>
            <div class="muted">{{ rowImportValue(row, 'sourceCountry') }} -> {{ rowImportValue(row, 'destinationCountry') }}</div>
          </td>
          <td>
            <strong>{{ rowImportValue(row, 'vehicleType') }}</strong>
            <div class="muted">{{ rowImportValue(row, 'vehicleConfig') }} / {{ rowImportValue(row, 'vehicleCapacity') }}</div>
          </td>
          <td>{{ rowImportValue(row, 'amount') }}</td>
          <td>{{ row.createdRateId || '-' }}</td>
          <td><span class="error-text">{{ row.errorMessage || '-' }}</span></td>
          <td class="text-right">
            <button pButton type="button" icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-secondary mr-2" (click)="openEditRow(row)"></button>
            <button pButton type="button" icon="pi pi-refresh" class="p-button-rounded p-button-text p-button-help" [disabled]="row.status !== 'FAILED' && row.status !== 'VALID'" (click)="retryRow(row)"></button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr><td colspan="8"><div class="empty-state">Upload a file or open a previous import batch.</div></td></tr>
      </ng-template>
    </p-table>
  </app-page-data-panel>

  <app-page-data-panel title="Import History" subtitle="Saved upload batches for delivery rate cards." [resultText]="importBatches.length + ' batches'">
    <p-table [value]="importBatches" dataKey="batchId" styleClass="p-datatable-gridlines" [tableStyle]="{ 'min-width': '52rem' }" [paginator]="true" [rows]="8">
      <ng-template pTemplate="header">
        <tr>
          <th>File</th>
          <th>Status</th>
          <th>Rows</th>
          <th>Created</th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-batch>
        <tr>
          <td>
            <strong>{{ batch.fileName || 'Import batch ' + batch.batchId }}</strong>
            <div class="muted">{{ batch.fileType }}</div>
          </td>
          <td><p-tag [value]="batch.status" [severity]="statusSeverity(batch.status)"></p-tag></td>
          <td>{{ batch.successRows || 0 }} success / {{ batch.failedRows || 0 }} failed / {{ batch.invalidRows || 0 }} invalid</td>
          <td>{{ batch.createdAt | date:'dd/MM/yyyy HH:mm' }}</td>
          <td class="text-right"><p-button label="Open" icon="pi pi-folder-open" severity="secondary" [outlined]="true" (onClick)="openBatch(batch)"></p-button></td>
        </tr>
      </ng-template>
    </p-table>
  </app-page-data-panel>
</app-page-shell>

<p-dialog [header]="rateForm.rateId ? 'Edit Delivery Rate Card' : 'Add Delivery Rate Card'" [(visible)]="formVisible" [modal]="true" [style]="{ width: 'min(96vw, 84rem)' }" styleClass="rate-card-dialog" [draggable]="false">
  <div class="rate-dialog-body">
    <div class="rate-dialog-summary">
      <div>
        <span>Contract</span>
        <strong>{{ formContract?.contractNumber || 'Not selected' }}</strong>
      </div>
      <div>
        <span>Revision</span>
        <strong>{{ formRevision?.revisionNumber || 'Not selected' }}</strong>
      </div>
      <div>
        <span>Lane</span>
        <strong>{{ countryById(rateForm.sourceCountryId)?.name || 'Source country' }} / {{ cityLabel(cityById(rateForm.sourceCityId)) || 'city' }} -> {{ countryById(rateForm.destinationCountryId)?.name || 'Destination country' }} / {{ cityLabel(cityById(rateForm.destinationCityId)) || 'city' }}</strong>
      </div>
      <div>
        <span>Amount</span>
        <strong>{{ rateForm.amount ? (rateForm.amount | currency:'SAR':'symbol':'1.2-2') : 'Pending' }}</strong>
      </div>
    </div>

    <app-page-form-section
      icon="fa-solid fa-file-signature"
      title="Contract Scope"
      subtitle="Bind the lane rate to the commercial agreement revision.">
      <div class="formgrid grid">
        <div class="field col-12 md:col-8">
          <p-inputGroup>
            <p-inputGroupAddon><i class="fa-solid fa-file-contract"></i></p-inputGroupAddon>
            <p-iftaLabel class="w-full">
              <p-select inputId="formContract" [options]="contracts" [(ngModel)]="formContract" optionLabel="contractNumber" [filter]="true" filterBy="contractNumber,firstParty.name,secondParty.name" (onChange)="onFormContractChange()" styleClass="w-full">
                <ng-template pTemplate="selectedItem" let-contract>
                  <span>{{ contractDisplayLabel(contract) }}</span>
                </ng-template>
                <ng-template pTemplate="item" let-contract>
                  <div class="contract-option">
                    <strong>{{ contract.contractNumber }}</strong>
                    <small>{{ contractPartiesLabel(contract) }}</small>
                  </div>
                </ng-template>
              </p-select>
              <label for="formContract">Contract</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>
        <div class="field col-12 md:col-4">
          <p-inputGroup>
            <p-inputGroupAddon><i class="fa-solid fa-code-branch"></i></p-inputGroupAddon>
            <p-iftaLabel class="w-full">
              <p-select inputId="formRevision" [options]="formRevisions" [(ngModel)]="formRevision" optionLabel="revisionNumber" styleClass="w-full"></p-select>
              <label for="formRevision">Revision</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>
      </div>
    </app-page-form-section>

    <app-page-form-section
      icon="fa-solid fa-route"
      title="Lane And Equipment"
      subtitle="Set the route pair, vehicle type, and specificity for matching.">
      <div class="formgrid grid">
        <div class="field col-12 md:col-6">
          <p-inputGroup>
            <p-inputGroupAddon><i class="fa-solid fa-globe"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <p-select inputId="formSourceCountry" [options]="countries" [(ngModel)]="rateForm.sourceCountryId" optionLabel="name" optionValue="id" [filter]="true" filterBy="name,countryCode" [showClear]="true" (onChange)="onFormSourceCountryChange()" styleClass="w-full"></p-select>
              <label for="formSourceCountry">Source Country</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>
        <div class="field col-12 md:col-6">
          <p-inputGroup>
            <p-inputGroupAddon><i class="fa-solid fa-earth-asia"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <p-select inputId="formDestinationCountry" [options]="countries" [(ngModel)]="rateForm.destinationCountryId" optionLabel="name" optionValue="id" [filter]="true" filterBy="name,countryCode" [showClear]="true" (onChange)="onFormDestinationCountryChange()" styleClass="w-full"></p-select>
              <label for="formDestinationCountry">Destination Country</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>
        <div class="field col-12 md:col-6">
          <p-inputGroup>
            <p-inputGroupAddon><i class="fa-solid fa-location-arrow"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <p-select inputId="formSourceCity" [options]="formSourceCities" [(ngModel)]="rateForm.sourceCityId" optionLabel="cityName" optionValue="id" [filter]="true" filterBy="cityName,country.name" [showClear]="true" (onChange)="onFormSourceCityChange()" styleClass="w-full">
                <ng-template pTemplate="selectedItem" let-city>
                  <span>{{ cityLabel(city) }}</span>
                </ng-template>
                <ng-template pTemplate="item" let-city>
                  <div class="city-option">
                    <strong>{{ cityLabel(city) }}</strong>
                    <small>{{ countryNameForCity(city) || 'No country' }}</small>
                  </div>
                </ng-template>
              </p-select>
              <label for="formSourceCity">Source City</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>
        <div class="field col-12 md:col-6">
          <p-inputGroup>
            <p-inputGroupAddon><i class="fa-solid fa-map-marker-alt"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <p-select inputId="formDestinationCity" [options]="formDestinationCities" [(ngModel)]="rateForm.destinationCityId" optionLabel="cityName" optionValue="id" [filter]="true" filterBy="cityName,country.name" [showClear]="true" (onChange)="onFormDestinationCityChange()" styleClass="w-full">
                <ng-template pTemplate="selectedItem" let-city>
                  <span>{{ cityLabel(city) }}</span>
                </ng-template>
                <ng-template pTemplate="item" let-city>
                  <div class="city-option">
                    <strong>{{ cityLabel(city) }}</strong>
                    <small>{{ countryNameForCity(city) || 'No country' }}</small>
                  </div>
                </ng-template>
              </p-select>
              <label for="formDestinationCity">Destination City</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>
        <div class="field col-12 md:col-4">
          <p-inputGroup>
            <p-inputGroupAddon><i class="fa-solid fa-truck"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <p-select inputId="formVehicleType" [options]="vehicleTypes" [(ngModel)]="rateForm.vehicleTypeId" optionLabel="name" optionValue="id" [filter]="true" filterBy="name" (onChange)="onFormVehicleTypeChange()" styleClass="w-full"></p-select>
              <label for="formVehicleType">Vehicle Type</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>
        <div class="field col-12 md:col-4">
          <p-inputGroup>
            <p-inputGroupAddon><i class="fa-solid fa-truck-front"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <p-select inputId="formVehicleConfig" [options]="formVehicleConfigs" [(ngModel)]="rateForm.vehicleConfigId" optionLabel="name" optionValue="configId" [filter]="true" filterBy="name" [showClear]="true" styleClass="w-full"></p-select>
              <label for="formVehicleConfig">Vehicle Config</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>
        <div class="field col-12 md:col-4">
          <p-inputGroup>
            <p-inputGroupAddon><i class="fa-solid fa-weight-hanging"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <p-select inputId="formVehicleCapacity" [options]="formVehicleCapacities" [(ngModel)]="rateForm.vehicleCapacityId" optionLabel="name" optionValue="capacityId" [filter]="true" filterBy="name" [showClear]="true" styleClass="w-full"></p-select>
              <label for="formVehicleCapacity">Vehicle Capacity</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>
        <div class="field col-12 md:col-4">
          <p-inputGroup>
            <p-inputGroupAddon><i class="fa-solid fa-road"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <p-inputNumber inputId="formDistance" [(ngModel)]="rateForm.distance" suffix=" km" [readonly]="true" styleClass="w-full"></p-inputNumber>
              <label for="formDistance">Distance (auto-calculated)</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>
      </div>
    </app-page-form-section>

    <app-page-form-section
      icon="fa-solid fa-coins"
      title="Commercial Terms"
      subtitle="Set freight amount, waiting charges, and included terms.">
      <div class="formgrid grid">
        <div class="field col-12 md:col-4">
          <p-inputGroup>
            <p-inputGroupAddon><i class="fa-solid fa-money-bill-wave"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <p-inputNumber inputId="formAmount" [(ngModel)]="rateForm.amount" mode="currency" currency="SAR" styleClass="w-full"></p-inputNumber>
              <label for="formAmount">Amount</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>
        <div class="field col-12 md:col-4">
          <p-inputGroup>
            <p-inputGroupAddon><i class="fa-solid fa-hourglass-half"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <p-inputNumber inputId="formWaitingThreshold" [(ngModel)]="rateForm.waitingThreshold" suffix=" mins" styleClass="w-full"></p-inputNumber>
              <label for="formWaitingThreshold">Waiting Threshold</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>
        <div class="field col-12 md:col-4">
          <p-inputGroup>
            <p-inputGroupAddon><i class="fa-solid fa-clock-rotate-left"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <p-inputNumber inputId="formWaitingCharge" [(ngModel)]="rateForm.waitingCharge" mode="currency" currency="SAR" styleClass="w-full"></p-inputNumber>
              <label for="formWaitingCharge">Waiting Charge</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>
        <div class="field col-12 md:col-6">
          <div class="option-toggle">
            <i class="fa-solid fa-shield-halved"></i>
            <div>
              <strong>Goods Insurance</strong>
              <span>{{ rateForm.goodsInsurance ? 'Included' : 'Excluded' }}</span>
            </div>
            <p-toggleswitch [(ngModel)]="rateForm.goodsInsurance"></p-toggleswitch>
          </div>
        </div>
        <div class="field col-12 md:col-6">
          <div class="option-toggle">
            <i class="fa-solid fa-stamp"></i>
            <div>
              <strong>Port Permit</strong>
              <span>{{ rateForm.portPermit ? 'Included' : 'Excluded' }}</span>
            </div>
            <p-toggleswitch [(ngModel)]="rateForm.portPermit"></p-toggleswitch>
          </div>
        </div>
      </div>
    </app-page-form-section>
  </div>
  <ng-template pTemplate="footer">
    <p-button label="Cancel" icon="pi pi-times" severity="secondary" [text]="true" (onClick)="formVisible = false"></p-button>
    <p-button label="Save Rate Card" icon="pi pi-check" [loading]="saving" (onClick)="saveRateCard()"></p-button>
  </ng-template>
</p-dialog>

<p-dialog header="Correct Import Row" [(visible)]="editRowDialogVisible" [modal]="true" [style]="{ width: 'min(94vw, 64rem)' }" [draggable]="false">
  <div class="edit-grid" *ngIf="editingRow">
    <label *ngFor="let column of importColumns">
      <span>{{ column }}</span>
      <input pInputText [(ngModel)]="editingValues[column]">
    </label>
  </div>
  <ng-template pTemplate="footer">
    <p-button label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true" (onClick)="editRowDialogVisible = false"></p-button>
    <p-button label="Save & Revalidate" icon="pi pi-check" (onClick)="saveRow()"></p-button>
  </ng-template>
</p-dialog>
